module.exports = __webpack_public_path__ + "media/src/website/images/logo-8952a73d0ecc964c220c39f9b72942b0.svg";